import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '../authentication/authentication';

const Home = () => {
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated) {
      return <Navigate to="/dashboard" replace />;
    }else {
      return <Navigate to="/login" replace />;
    }
 
}

export default Home;
